import type { LoggingConfig } from "$src/core/models/logging";
import SentryService from "$src/core/services/logging/sentry";

type WrapFn = <P extends Record<string, unknown>>(
  RootComponent: React.ComponentType<P>,
) => React.ComponentType<P>;

export type Extra = {
  error?: unknown;
  [key: string]: unknown;
};

export type LoggingService = {
  wrap?: WrapFn;
  init?: (config: LoggingConfig) => void;
  registerNavigationContainer?: (ref: unknown) => void;
  error: (errorOrMessage: unknown, extra?: Extra) => void;
  warn: (errorOrMessage: unknown, extra?: Extra) => void;
  info: (message: string, extra?: Extra) => void;
  debug: (message: string, extra?: Extra) => void;
};

const Logging: LoggingService = SentryService;

export default Logging;
